import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  StyledTable as Table,
  StyledTableHead as THead,
  StyledTableRow as TR,
  StyledTableHeader as TH,
  StyledTableCell as TD,
  StyledButtonVisualizar,
  DesktopOnly,
  MobileCards,
  MobileCard,
  MobileCardTitle,
  MobileCardMeta,
  MobileCardActions,
} from "./styles";
import { richTextToPlainText } from "../../../../utils/richText";
import { openAlertDetails } from "../../../../utils/appNavigation";

export const TableAlertTickets = ({ alertTickets }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const ACTION_LABELS = {
    criado: "Alerta criado",
    recebido: "Recebido",
    aguardando_resposta: "Aguardando Resposta",
    resposta_rejeitado: "Resposta Rejeitada",
    equipe_enviada: "Equipe Enviada",
    respondido_processo_sucessao: "Respondido / Processo de Sucessão Natural",
    encerrado: "Encerrado",
  };

  const formatAction = (action) => ACTION_LABELS[action] ?? action;

  const handleClick = (ticket) => {

    const original = alertTickets.find(
      (item) => (item.ticket_id || item.id) === ticket.ticket_id
    );

    openAlertDetails(dispatch, navigate, { ticketId: ticket.ticket_id });
  };

  const normalizeData = (data) => {
    if (!data || data.length === 0) return [];

    return data.map((item) => ({
      ticket_id:
        item.ticket_id ||
        item.id ||
        Math.random().toString(36).substr(2, 9),
      alert_type_description: item.alert_type_description || "-",
      severity_level_description: item.severity_level_description || "-",
      coordinates: item.coordinates || "-",
      alert_created_at: item.alert_created_at || null,
      area_title: item.area_title || "-",
      responses: item.responses || "-",
      alert_observation: richTextToPlainText(item.alert_observation) || "-",
      ticket_observations: richTextToPlainText(item.observations) || "-",
      alert_user: item.alert_user || "-",
      ticket_user: item.ticket_user || "-",
      action: item.action || "-",
      area_id_code: item.area_id_code || null,
    }));
  };

  const normalizedData = normalizeData(alertTickets);

  if (!normalizedData || normalizedData.length === 0) {
    return (
      <div
        style={{
          color: "var(--text-secondary)",
          textAlign: "center",
          padding: "20px",
          backdropFilter: "blur(20px)",
          background: "var(--surface-glass)",
          borderRadius: "20px",
          border: "2px solid var(--border-subtle)",
        }}
      >
        <p>Nenhum dado disponível</p>
      </div>
    );
  }

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      return isNaN(date.getTime())
        ? "-"
        : date.toLocaleDateString("pt-BR") +
        " " +
        date.toLocaleTimeString("pt-BR");
    } catch (e) {
      return "-";
    }
  };

  return (
    <>
      <DesktopOnly>
        <Table>
          <THead>
            <TR>
              <TH>Área</TH>
              <TH>Data</TH>
              <TH>Tipo</TH>
              <TH>Severidade</TH>
              <TH>Coordenadas</TH>
              <TH>Ação</TH>
              <TH>Observação</TH>
              <TH></TH>
            </TR>
          </THead>
          <tbody>
            {normalizedData.map((ticket) => (
              <TR key={ticket.ticket_id}>
                <TD
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                  onClick={() =>
                    navigate(`/area_details/${ticket.area_id_code}`)
                  }
                >
                  {ticket.area_title}
                </TD>
                <TD>{formatDate(ticket.alert_created_at)}</TD>
                <TD>{ticket.alert_type_description}</TD>
                <TD>{ticket.severity_level_description}</TD>
                <TD>{ticket.coordinates}</TD>
                <TD>{formatAction(ticket.action)}</TD>
                <TD>{ticket.alert_observation}</TD>
                <TD>
                  <StyledButtonVisualizar onClick={() => handleClick(ticket)}>
                    Visualizar
                  </StyledButtonVisualizar>
                </TD>
              </TR>
            ))}
          </tbody>
        </Table>
      </DesktopOnly>

      <MobileCards>
        {normalizedData.map((ticket) => (
          <MobileCard key={`m-${ticket.ticket_id}`}>
            <MobileCardTitle
              style={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={() =>
                ticket.area_id_code &&
                navigate(`/area_details/${ticket.area_id_code}`)
              }
            >
              {ticket.area_title}
            </MobileCardTitle>
            <MobileCardMeta>
              {ticket.alert_type_description} ·{" "}
              {ticket.severity_level_description}
            </MobileCardMeta>
            <MobileCardMeta>
              {formatDate(ticket.alert_created_at)}
            </MobileCardMeta>
            <MobileCardMeta>{ticket.coordinates}</MobileCardMeta>
            <MobileCardMeta>{formatAction(ticket.action)}</MobileCardMeta>
            {ticket.alert_observation && ticket.alert_observation !== "-" ? (
              <MobileCardMeta>{ticket.alert_observation}</MobileCardMeta>
            ) : null}
            <MobileCardActions>
              <StyledButtonVisualizar onClick={() => handleClick(ticket)}>
                Visualizar
              </StyledButtonVisualizar>
            </MobileCardActions>
          </MobileCard>
        ))}
      </MobileCards>
    </>
  );
};
